var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvseStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 232,
    height: 169,
    viewBox: "0 0 232 169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_442",
    "data-name": "Group 442",
    transform: "translate(-275 -332)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_191",
    "data-name": "Ellipse 191",
    cx: 50,
    cy: 49.5,
    rx: 50,
    ry: 49.5,
    transform: "translate(352 332)",
    fill: "#25556e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_201",
    "data-name": "Ellipse 201",
    cx: 44.5,
    cy: 44.5,
    r: 44.5,
    transform: "translate(289 412)",
    fill: "#25556e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_200",
    "data-name": "Ellipse 200",
    cx: 34.5,
    cy: 34.5,
    r: 34.5,
    transform: "translate(275 341)",
    fill: "#3a8814"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_193",
    "data-name": "Ellipse 193",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(384 439)",
    fill: "#25556e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_194",
    "data-name": "Ellipse 194",
    cx: 39.5,
    cy: 40.5,
    rx: 39.5,
    ry: 40.5,
    transform: "translate(421 419)",
    fill: "#fdbb1d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_196",
    "data-name": "Ellipse 196",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(490 408)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_197",
    "data-name": "Ellipse 197",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(457 388)",
    fill: "#e96a24"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Connected",
    transform: "translate(378 385)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Connected")), /*#__PURE__*/React.createElement("text", {
    id: "Available",
    transform: "translate(314 460)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Available")), /*#__PURE__*/React.createElement("text", {
    id: "Charging",
    transform: "translate(441 463)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Charging")), /*#__PURE__*/React.createElement("text", {
    id: "Complete",
    transform: "translate(288 379)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Complete")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvseStatus);
export default __webpack_public_path__ + "static/media/evse_status.ea20a79f0722dfb1535fc803f3a25ffb.svg";
export { ForwardRef as ReactComponent };